<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        filter: function(){
            let state = this;
            state.items = [];
            state.errors = [];

            if(state.userType == 'USER-CUSTOMER'){
                $('#spinner').modal('toggle');
                Request.do(state, 'POST', Request.getDefaultHeader(state),state.filters, `${Endpoints.systemUsers.customerUser}`,
                (response)=>{//SUCCESS CALLBACK
                    state.items = response.results;
                    console.log(state.items);
                    $('#spinner').modal('toggle');  
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                });
            }
            else
            if(state.userType == 'USER-COMPANY'){
                if(state.filters.name.length >= 3){
                    $('#spinner').modal('toggle');
                    Request.do(state, 'POST', Request.getDefaultHeader(state), state.filters, `${Endpoints.companies.companyUser}`,
                    (response)=>{//SUCCESS CALLBACK
                        state.items = response.results;
                        console.log(state.items);
                        $('#spinner').modal('toggle');  
                    },
                    (error)=>{//ERROR CALLBACK
                        console.log(error);
                    });
                }
                else
                {  state.errors.push(state.$t('string.msg.name.min.four.caracter')); }
            }
            else
            if(state.userType == null){
                state.errors.push(state.$t('string.msg.filter.search.user.type'));
            }
        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        getPageNumbers: function(){
            return this.items.length/10;
        },
        selectItem: function(item){
           $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;

            console.log(this.order._id);
            console.log(item.company);


            this.data._id = this.order._id;
            this.data.company = item._id;

            Request.do(this, 'PUT', Request.getDefaultHeader(this), this.data,  `${Endpoints.orders.holder.addCompany}`,
                (response)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    $('#modalAddUserChat').modal('toggle');
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
         
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>